// eslint-disable-next-line no-restricted-imports
import { useIntl as _useIntl } from 'react-intl';
import { env } from '@pass-frontend/features/configuration/util';
import { useStableCallback } from '@pass-frontend/utility/swiss-knife';

/** Appears in i18n strings as {onePassCopy}  */
const ONE_PASS_TEXT_VARIABLE = 'onePassCopy';

export const useIntl = () => {
  const { ENABLE_ONE_PASS_SELECT_COPY: enableOnePassSelectCopy } = env();
  const { formatMessage } = _useIntl();

  const onePassReplacementText = enableOnePassSelectCopy
    ? formatMessage({ id: 'common.onePassSelect' })
    : formatMessage({ id: 'common.onePass' });

  const t = useStableCallback((id: string, vars = {}) => {
    return formatMessage(
      { id },
      {
        ...vars,
        [ONE_PASS_TEXT_VARIABLE]: onePassReplacementText,
      },
    );
  });

  return {
    t,
  };
};
